export enum MfaType {
    Email = 1,
    Sms = 2,
    Call = 3,
  }

